var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStroke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4.50012C22 5.88082 21.6162 7.00012 21.1429 7.00012L2.85714 7.00012C2.38376 7.00012 2 5.88082 2 4.50012C2 3.11942 2.38376 2.00012 2.85714 2.00012L21.1429 2.00012C21.6162 2.00012 22 3.11942 22 4.50012Z",
    fill: "#FF5E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 11.5001C21 12.3285 20.6546 13.0001 20.2286 13.0001L3.77143 13.0001C3.34538 13.0001 3 12.3285 3 11.5001C3 10.6717 3.34538 10.0001 3.77143 10.0001L20.2286 10.0001C20.6546 10.0001 21 10.6717 21 11.5001Z",
    fill: "#F26E21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 16.5883C20 17.1405 19.693 17.5883 19.3143 17.5883L4.68571 17.5883C4.30701 17.5883 4 17.1405 4 16.5883C4 16.036 4.30701 15.5883 4.68571 15.5883L19.3143 15.5883C19.693 15.5883 20 16.036 20 16.5883Z",
    fill: "#CF6729"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21.2941C5 20.9043 5.31603 20.5883 5.70588 20.5883L7.58824 20.5883C7.97808 20.5883 8.29412 20.9043 8.29412 21.2941C8.29412 21.684 7.97808 22 7.58824 22L5.70588 22C5.31603 22 5 21.684 5 21.2941ZM10.3529 21.2941C10.3529 21.684 10.669 22 11.0588 22L12.9412 22C13.331 22 13.6471 21.684 13.6471 21.2941C13.6471 20.9043 13.331 20.5883 12.9412 20.5883L11.0588 20.5883C10.669 20.5883 10.3529 20.9043 10.3529 21.2941ZM16.4118 20.5883C16.0219 20.5883 15.7059 20.9043 15.7059 21.2941C15.7059 21.684 16.0219 22 16.4118 22L18.2941 22C18.684 22 19 21.684 19 21.2941C19 20.9043 18.684 20.5883 18.2941 20.5883L16.4118 20.5883Z",
    fill: "#A93E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroke);
export default __webpack_public_path__ + "static/media/stroke.f721bde4814808b2371c3928d0793454.svg";
export { ForwardRef as ReactComponent };